<template>
  <li
    class="-file"
    :class="{
      '-has-error': file.error,
    }"
    @click.meta="$_dumpData"
  >
    <div class="-name" v-text="file.name" />
    <div class="-size" v-text="fileSize" />

    <i
      v-if="file.error"
      class="-error wticon wticon-information1"
      v-tooltip.extend="{
        title: file.error,
        delay: 0,
      }"
    />

    <i class="-remove wticon wticon-close" title="Remove" @click="onRemove" />
  </li>
</template>

<script>
export default {
  props: {
    file: { type: [Object, File], required: true },
  },

  computed: {
    fileSize() {
      const MB = 1e6;
      const KB = 1e3;

      let size =
        (this.file.size || this.file.bytes || this.file.sizeBytes) / MB;

      if (size > 1) {
        return `${Math.round(size).toFixed(0)} MB`;
      } else if (size > 0.1) {
        return `${size.toFixed(1)} MB`;
      } else {
        size *= KB;
        return `${Math.round(size).toFixed(0)} KB`;
      }
    },
  },

  methods: {
    onRemove() {
      this.$emit('remove-file-record', { file: this.file });
    },

    $_dumpData() {
      this.$log(this.$props.file);
    },
  },
};
</script>
